'use strict';
import React from 'react';
import API from 'sources/API';
import Moment from 'moment';
import {Link} from 'react-router';
import Navigator from './NavigatorComponent';
import {BounceLoader} from 'react-spinners';

require('styles/Referral.scss');
require('styles/SweetLoading.scss');

class OpportunityReferralComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      maxCount: 50,
      opportunity: {},
      user: {},
      addition: null,
      loading: false
    }
    this.handleReferral = this.handleReferral.bind(this)
    this.reloadData = this.reloadData.bind(this)
    this.updateWechatShare = this.updateWechatShare.bind(this)
  }
  componentWillMount() {
    this.reloadData()
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }
    this.updateWechatShare(this.state.opportunity)
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  reloadData() {
    this.setState({loading: true})
    const sendData = {
      first: this.state.first,
      maxCount: this.state.maxCount,
      user_id: this.props.location.query.uid
    };
    let searchParams = new URLSearchParams();
    for(let k in sendData) {
      if(sendData[k] === 0 || sendData[k]) {
        searchParams.append(k, sendData[k]);
      }
    }
    const opp_id = this.props.params.id
    fetch(`${API.getOpportunityReferral.replace(':id',opp_id)}&${searchParams}`)
    .then(res=>res.json())
    .then(json=>{
      const { opportunity,user,addition,is_referral } = json.result
      this.setState({
        opportunity: opportunity,
        user: user,
        addition: addition,
        is_referral: is_referral,
        loading: false
      })
      this.updateWechatShare(opportunity)
    });
  }
  handleReferral() {
    let check = API.checkToken;
    if(check){
      if(!this.state.loading) {
        this.setState({loading: true})
        let param = {
          method: 'POST',
          body: JSON.stringify({
            user_id: this.props.location.query.uid
          }),
          headers: API.jsonHeader
        };
        const opp_id = this.props.params.id
        fetch(API.postOpportunityReferral.replace(':id',opp_id), param)
        .then(res=>res.json()
        .then(json=>{
          if(json.status == 0){
            this.setState({loading: false})
            this.reloadData()
          }
        }))
      }
    }
  }
  updateWechatShare(opportunity) {
    if (opportunity&&opportunity._id) {
      let { title, imageUrl } = opportunity;
      window.wx.onMenuShareTimeline({
        title: `活动助力：${title}-小地球旅行`,
        link:  location.href,
        imgUrl: encodeURI(imageUrl.replace('list','li150'))
      });
      window.wx.onMenuShareAppMessage({
        title: `活动助力：${title}-小地球旅行`,
        desc: `${title}。加入小地球旅行，发现有趣的地方`,
        link: location.href,
        imgUrl: encodeURI(imageUrl.replace('list','li150')),
        type: 'link'
      });
    }
  }
  render() {
    let {tel,wechat_name} = this.state.user
    if(tel){
      tel = tel.replace(tel.substring(3,tel.length - 4),'****')
    }
    if(wechat_name){
      wechat_name = wechat_name.replace(wechat_name.substring(2,wechat_name.length),'**')
    }
    const addition = this.state.addition?this.state.addition:{
      relation_info:{},
      referral_users:[],
      referral_number: 0
    }
    return <div className="referral-component">
      <div className='sweet-loading'>
        <BounceLoader
          sizeUnit={"px"}
          size={50}
          color={'#333'}
          loading={this.state.loading}
        />
      </div>
      <div className="referal-user-card">
        <div className="img-wrap">
          <img src={this.state.user.avatar} />
        </div>
        <div className="nickname">{this.state.user.name}</div>
        <div className="contacts">
          <div className="email">wechat: {wechat_name || '***'}</div>
          <div className="phone">tel: {tel || '***'}</div>
        </div>
        <div className="message">{addition.relation_info.msg}</div>
      </div>
      <Link to={`/opportunity/${this.props.params.id}`} className="opportunity-card">
        <div>
          <div className="cover-wrap">
            <img src={this.state.opportunity.imageUrl} />
          </div>
          <div className="title">{this.state.opportunity.title}</div>
        </div>
      </Link>
      <div className="referral-card">
        {this.state.is_referral?<div className="referral-action completed">已助力</div>
         :<div className="referral-action" onClick={this.handleReferral}>为他助力</div>}
        <div className="referrals">
          <div className="title">
            <span className="tag">已助力成员 {addition.referral_number}位</span>
          </div>
          {addition.referral_users&&addition.referral_users.length?
            addition.referral_users.map(user => {
            return (
              <div className="referral" key={user._id}>
                <div className="avatar-wrap">
                  <img src={user.avatar} />
                </div>
                <div className="identity">
                  <div className="nickname">{user.name}</div>
                  <div className="intro">加入时间：{Moment(user.create_date).format('YYYY-MM-DD')}</div>
                </div>
              </div>
            )
          }):<div className="empty">暂无助力</div>}
        </div>
      </div>
      <Navigator action='home' number={3} />
      <Navigator action='top' number={2} />
      <Navigator action='left' number={1} />
    </div>
  }
}

OpportunityReferralComponent.displayName = 'OpportunityReferralComponent';
export default OpportunityReferralComponent;



// WEBPACK FOOTER //
// ./src/components/OpportunityReferralComponent.js